import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import useGetUserProfileInfo from '@/hooks/auth/useGetUserProfileInfo';
import { CopyIcon } from 'lucide-react';
import PaymentOptions from '@/components/deposit/PaymentOptions';
import { useSession } from '@/contexts/LitSessionProvider';
import { toast } from 'sonner';
import { LiaBugSolid } from 'react-icons/lia';
import DeskTopWalletQr from './DeskTopWalletQr';
import DepositMethods from '@/components/deposit/DepositMethods';
import { show } from '@intercom/messenger-js-sdk';
export default function DesktopDeposit() {
  const [selectWallet, setSelectWallet] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<'coinbase' | 'binance' | 'apple' | 'google' | 'card' | 'bank' | 'evm' | 'solana' | null>(null);
  const {
    userName
  } = useGetUserProfileInfo();
  const {
    PKP
  } = useSession();
  return <div data-sentry-component="DesktopDeposit" data-sentry-source-file="DesktopDeposit.tsx">
      <div className='mt-2 text-genius-cream '>
        <div className='ta-c'>
          <p className='text-[24px]'>Deposit via</p>
        </div>
        {selectWallet && (selectedPaymentMethod === 'evm' || selectedPaymentMethod === 'solana') ? <DeskTopWalletQr setSelectWallet={setSelectWallet} selectedPaymentMethod={selectedPaymentMethod} setSelectedPaymentMethod={setSelectedPaymentMethod} PKP={PKP} /> : selectedPaymentMethod === 'coinbase' || selectedPaymentMethod === 'binance' || selectedPaymentMethod === 'apple' || selectedPaymentMethod === 'google' || selectedPaymentMethod === 'card' || selectedPaymentMethod === 'bank' ? <DepositMethods selectedPaymentMethod={selectedPaymentMethod} setSelectedPaymentMethod={setSelectedPaymentMethod} PKP={PKP} /> : <>
            <div className='text-[16px] border border-genius-blue rounded-md mx-4 mt-6 p-2 flex justify-between items-center text-genius-cream'>
              {userName}
              <CopyIcon onClick={async () => {
            await navigator.clipboard.writeText(userName);
            toast.success(`Copied ${userName} to your clipboard`, {
              duration: 2000
            });
          }} className='text-genius-cream/50 text-[14px] mx-2' />
            </div>

            <PaymentOptions showDialog={false} setSelectWallet={setSelectWallet} setSelectedPaymentMethod={setSelectedPaymentMethod} />
          </>}
      </div>
      {!selectedPaymentMethod && <div className='ta-c'>
          <p className='text-genius-cream/50 text-xs mt-16 text-left w-full flex px-4 flex-col  '>
            {' '}
            Deposits may take up to 30 seconds to reflect in your account.
            <br></br>
            <br></br>Note: If you’re depositing on Ethereum Mainnet , the minimum order must be over
            $75 due to gas fees.
          </p>
          <Button onClick={() => {
        show();
      }} className={`h-[56px] flex items-center w-full mt-[75px] bg-genius-blue rounded-full text-genius-cream 
                text-[14px]`} variant='ghost'>
            <LiaBugSolid className='mr-1' /> Get Help
          </Button>
        </div>}
    </div>;
}